import { render, staticRenderFns } from "./CustomerSurvey.vue?vue&type=template&id=595ac2fe"
import script from "./CustomerSurvey.vue?vue&type=script&lang=js"
export * from "./CustomerSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports